import { useAppState } from "src/state"

import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { TalentAdminLinkCards } from "src/components/talent/TalentAdminLinkCards"

export const TalentAdminHome = () => {

    const userName = useAppState(state=>state.user_name)

    return (
        <PageLayout
            header={<PageHeader
                title={`Welcome ${userName}`}
            />
            }>
                <TalentAdminLinkCards />
        </PageLayout>
    )
}